import {
  BookingTool,
  OrganisationEdge,
  OrganisationPage,
} from "../../../AppDataProvider/AppDataProvider";

export const filterAndSortOrganisations = (
  organisationsToFilter: OrganisationPage,
  locationSelection: BookingTool["locationSelection"]
): OrganisationPage => {
  const organisationsSortedByProximity = [...organisationsToFilter.edges].sort(
    (a: OrganisationEdge, b: OrganisationEdge) =>
      a.node.proximityToSearchedLocation &&
      b.node.proximityToSearchedLocation &&
      a.node.proximityToSearchedLocation > b.node.proximityToSearchedLocation
        ? 1
        : -1
  );

  /**
   * Filter organisations based on maxLocationsToDisplay & maxLocationSearchRange
   */
  let organisations: OrganisationPage = {
    ...organisationsToFilter,
    edges: organisationsSortedByProximity.filter(({ node }, index) => {
      // exclude organisation if we have exceeded maxLocationsToDisplay
      if (
        locationSelection &&
        locationSelection.maxLocationsToDisplay &&
        index >= locationSelection.maxLocationsToDisplay
      ) {
        return false;
      }

      // exclude organisation if the organisations have exceeds the maxLocationSearchRange
      if (
        locationSelection?.maxLocationSearchRange &&
        node.proximityToSearchedLocation &&
        node.proximityToSearchedLocation >
          locationSelection.maxLocationSearchRange
      ) {
        return false;
      }

      return true;
    }),
  };

  /**
   * If there is no organisations within range
   * we need to select the closest x organisations based on
   * the minLocationsToDisplay value.
   */
  if (
    locationSelection?.minLocationsToDisplay &&
    organisations.edges.length === 0
  ) {
    organisations = {
      ...organisationsToFilter,
      edges: organisationsSortedByProximity.slice(
        0,
        locationSelection.minLocationsToDisplay
      ),
    };
  }

  return organisations;
};
